import utils from "./utils";
let wxApi = {
  // 检测政务微信版本号
  check_ver: function () {
    var download_link =
      "http://sj.qq.com/myapp/detail.htm?apkName=com.tencent.weworklocal";
    var min_ver = "2.1";
    var ua = navigator.userAgent;
    var pa = /\/(\d{1,3}\.\d{1,3}\.\d{1,3})\swxworklocal/g;
    var ver = pa.exec(ua);
    if (ver && ver[1]) {
      //检测到了版本号，进行比较
      if (!wxApi.ver_compare(ver[1], min_ver)) {
        alert("当前政务微信版本过低，请更新");
        window.location.href = download_link;
        return false;
      }
    }
    return true;
  },
  /* 初始化微信js-sdk配置 */
  initConfig: function (config) {
    function jsdkCB(data) {
      let jsApiList = ["getNetworkType", "agentConfig"];
      if (typeof window["wx"] !== "object") {
        return;
      }
      if (!config) {
        config = {};
      }
      jsApiList = jsApiList.concat(config.jsApiList || []);
      let wxError = {
        status: "",
        errmsg: "配置失败，请退出重试",
      };
      if (data.appid) {
        window["wx"].config({
          beta: true,
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appid, // 必填，政务微信的cropID
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonce, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          jsApiList: jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        window["wx"].ready(function () {
          console.log("ps_config注册成功 => 开启registerAgentConfig");
          // typeof config.sucesscb === "function" && config.sucesscb();
          // 调用agentConfig
          wxApi.registerAgentConfig(data, config);
        });
        window["wx"].error(function (e) {
          console.error("initConfig wx error:", e);
          typeof config.errorcb === "function" && config.errorcb(wxError);
        });
      }
    }
    let url = `https://xtbgtest.digitalgd.com.cn/dsauth/auth/pedestal/ticket/execute?state=${window.location.origin}${window.location.pathname}`;
    if (process.env.VUE_APP_ENV == "4") {
      url = `https://cxgly.gdzwfw.gov.cn/auth/pedestal/ticket/execute?state=${window.location.origin}${window.location.pathname}`;
    }
    utils.xhrRequest({}, "get", url, jsdkCB);
  },

  registerAgentConfig: function (data, config) {
    let url = `https://xtbgtest.digitalgd.com.cn/dsauth/auth/pedestal/ticket/execute?state=${window.location.origin}${window.location.pathname}&token=agent_config`;
    if (process.env.VUE_APP_ENV == "4") {
      url = `https://cxgly.gdzwfw.gov.cn/auth/pedestal/ticket/execute?state=${window.location.origin}${window.location.pathname}&token=agent_config`;
    }
    utils.xhrRequest({}, "get", url, (res) => {
      // console.log(
      //   JSON.stringify({
      //     agentid: res.agentid, // 必填，单位应用的agentid
      //     corpid: data.appid, // 必填，政务微信的corpid
      //     timestamp: res.timestamp, // 必填，生成签名的时间戳,int类型, 如 1539100800
      //     nonceStr: res.nonce, // 必填，生成签名的随机串
      //     signature: res.signature, // 必填，签名，见附录5
      //   })
      // );
      window["wx"].invoke(
        "agentConfig",
        {
          agentid: res.agentid, // 必填，单位应用的agentid
          corpid: data.appid, // 必填，政务微信的corpid
          timestamp: res.timestamp, // 必填，生成签名的时间戳,int类型, 如 1539100800
          nonceStr: res.nonce, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录5
        },
        function (res) {
          console.log(res);
          if (res.err_msg != "agentConfig:ok") {
            //错误处理
            console.log("ps_agentConfig注册失败", res);
            return;
          } else {
            console.log("ps_agentConfig注册成功");
            typeof config.sucesscb === "function" && config.sucesscb();
          }
        }
      );
    });
  },

  loadWxApi: function (cb) {
    let src = "//res.wx.qq.com/open/js/jweixin-1.2.0.js";
    utils.loadScript(src, cb);
  },

  getNetworkType: function (successcb, failcb) {
    window["wx"].getNetworkType({
      success: function (res) {
        typeof successcb === "function" && successcb(res.networkType);
      },
      fail: function (res) {
        console.log(res, "==getNetworkType");
        typeof failcb === "function" && failcb();
      },
    });
  },

  ver_compare: function (ver_source, ver_target) {
    /**
     * 判断ver_source是否大于等于var_target
     * 由于不清楚微信命名规则，则假设可以命名为 1.12.9
     * 则需要每个版本号分开单独比较．
     */
    var result = true;
    var source = ver_source.split(".");
    var target = ver_target.split(".");
    if (target.length !== 3 || source.length !== 3) {
      //版本有误
      return false;
    }
    for (var i = 0; i < target.length; i++) {
      var t = parseInt(target[i]);
      var s = parseInt(source[i]);
      if (t > s) {
        //源小于目标版本，直接为版本太低
        result = false;
        break;
      }
      if (t == s) {
        //源等于目标版本，继续比较
        continue;
      }
      if (t < s) {
        //源大于目标版本，直接符合
        result = true;
        break;
      }
    }
    return result;
  },
};
export default wxApi;
